var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 4.66671H11.9998C11.6462 4.66671 11.3071 4.52623 11.057 4.27618C10.807 4.02613 10.6665 3.687 10.6665 3.33337V1.33337",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 4.00004V8.33337C14.0002 8.86671 13.5335 9.33337 13.0002 9.33337H8.3335C7.80016 9.33337 7.3335 8.86671 7.3335 8.33337V2.33337C7.3335 1.80004 7.80016 1.33337 8.3335 1.33337H11.3335L14.0002 4.00004Z",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 5.33337V11.2C4.6665 11.4 4.79984 11.6 4.93317 11.7334C5.0665 11.8667 5.2665 12 5.4665 12H9.99984",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8V13.8667C2 14.0667 2.13333 14.2667 2.26667 14.4C2.4 14.5333 2.6 14.6667 2.8 14.6667H7.33333",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecords);
export default __webpack_public_path__ + "static/media/Records.8b5bf6a548853e698b24a0b2f0411d32.svg";
export { ForwardRef as ReactComponent };